import React, { useState } from 'react';
import 'react-image-lightbox/style.css';
import Lightbox from 'react-image-lightbox';
import "./newsevent.css";


import WSDOimg1 from '../../assets/wsdoimg1.jpg';
import WSDOimg2 from '../../assets/wsdoimg2.jpg';
import WSDOimg3 from '../../assets/wsdoimg3.jpg';
import WSDOimg4 from '../../assets/wsdoimg4.jpg';
import WSDOimg5 from '../../assets/wsdoimg5.jpg';
import WSDOimg6 from '../../assets/wsdoimg6.jpg';
import WSDOimg7 from '../../assets/wsdoimg7.jpg';
import WSDOimg8 from '../../assets/wsdoimg8.jpg';
import WSDOimg9 from '../../assets/wsdoimg9.jpg';
import WSDOimg10 from '../../assets/wsdoimg10.jpg';
import WSDOimg11 from '../../assets/wsdoimg11.jpg';
import WSDOimg12 from '../../assets/wsdoimg12.jpg';
import WSDOimg13 from '../../assets/wsdoimg13.jpg';
import WSDOimg14 from '../../assets/wsdoimg14.jpg';
import WSDOimg15 from '../../assets/wsdoimg15.jpg';
import WSDOimg16 from '../../assets/wsdoimg16.jpg';
import WSDOimg17 from '../../assets/wsdoimg17.jpg';
import WSDOimg18 from '../../assets/wsdoimg18.jpg';





const sections = [
  {
   
    images: [WSDOimg1, WSDOimg2, WSDOimg3, WSDOimg4, WSDOimg5, WSDOimg6, WSDOimg7, WSDOimg8, WSDOimg9, WSDOimg10, WSDOimg11, WSDOimg12 , WSDOimg13, WSDOimg14, WSDOimg15, WSDOimg16 , WSDOimg17 , WSDOimg18],
  },
];

const WorldSightDayOld = () => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);
  const [currentImages, setCurrentImages] = useState([]);

  const openViewer = (images, index) => {
    setCurrentImages(images);
    setPhotoIndex(index);
    setIsViewerOpen(true);
  };

  const closeViewer = () => {
    setIsViewerOpen(false);
  };

  return (
    <div className="gallery">
      <h1 align="center">World Sight Day - 2023</h1>
      <p class="intro-text">
  World Sight Day 2023, celebrated by the Eye Care Institute, 
  focused on raising awareness about the importance of eye health and preventing avoidable blindness. 
  The event brought together healthcare professionals, advocates, 
  and communities to emphasize the significance of early detection and proper care in preserving vision.
</p>
<br />

      {sections.map((section, sectionIndex) => (
        <div key={sectionIndex} className="gallery-section">
          <div className="gallery-header">
            <h2>{section.title}</h2>
          </div>
          <div className="gallery-grid">
            {section.images.map((src, index) => (
              <div key={index} className="gallery-item">
                <div className="overlay-container">
                <img
                    src={src}
                    alt={`Gallery item ${index + 1} in ${section.title}`} // Avoid the word "image"
                    className="gallery-image"
                    onClick={() => openViewer(section.images, index)}
                  />

                  <div className="overlay">
                    <button
                      className="max-view-button"
                      onClick={() => openViewer(section.images, index)}
                    >
                      <span>&#x2922;</span> {/* Fullscreen icon */}
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {isViewerOpen && (
        <Lightbox
          mainSrc={currentImages[photoIndex]}
          nextSrc={currentImages[(photoIndex + 1) % currentImages.length]}
          prevSrc={
            currentImages[
              (photoIndex + currentImages.length - 1) % currentImages.length
            ]
          }
          onCloseRequest={closeViewer}
          onMovePrevRequest={() =>
            setPhotoIndex(
              (photoIndex + currentImages.length - 1) % currentImages.length
            )
          }
          onMoveNextRequest={() =>
            setPhotoIndex((photoIndex + 1) % currentImages.length)
          }
        />
      )}
    </div>
  );
};
export default WorldSightDayOld